import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
// import ReactGA from 'react-ga';

import logo from "./logo.svg";
import "./App.css";
import "./styles/seims.css";

import CustomLayout from "./containers/CustomLayout";
import { logoutInstanceEventListener } from "@seims/shared/src/security";

function App({failedStart, message}) {
  const location = useLocation();
  const [authInit, setAuthInit] = useState(false);
  // const TRACKING_ID = "G-9M3CLY03J3";
  const navigate = useNavigate();
  const formRef = useRef();


  //This is disabled at the moment because of the Global (from index.html page) setting which will be moved to this component so that Google Analytics tracking can be managed
  //ReactGA.initialize(TRACKING_ID);
  useEffect(() => {
    // Google Analytics tracking is currently disabled
    //ReactGA.pageview(window.location.pathname + window.location.search);
    logoutInstanceEventListener();
    setAuthInit(failedStart);

    if (failedStart) {

      let path = `/autherror`;
      navigate(path, { state: { message: message } });
    }
    else if (location?.pathname?.toString().startsWith('/nys/candidate/details/'))
    {
      navigate(location.pathname);
    }
    else 
    {
      navigate(location.pathname);
    }

  }, [failedStart]);

  return (
    <div className="App">
      <CustomLayout />
    </div>
  );
}

export default App;
